// removed by extract-text-webpack-plugin
module.exports = {"selected-info":"SelectionInformation__selected-info___1_3eJ"};